import React from 'react';
import PropTypes from 'prop-types';
import ShowMoreComponent from '@Components/Results/utils/show-more.component';
import InnerHTML from '@Components/InnerHTML';

const DEFAULT_CHEMICAL_NAMES_COUNT = 7;

export default class SubstanceIdentificationChemicalNamesList extends React.PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    const { fullChemicalNamesList } = prevState;
    const { chemicalNames: nextChemicalNames = [] } = nextProps;

    const areNamesListsEqual =
      fullChemicalNamesList.length === nextChemicalNames.length && nextChemicalNames.every((name) => fullChemicalNamesList.includes(name));

    if (areNamesListsEqual) {
      return prevState;
    }

    return {
      fullChemicalNamesList: nextChemicalNames,
      chemicalNamesList: nextChemicalNames.slice(0, DEFAULT_CHEMICAL_NAMES_COUNT),
    };
  }

  constructor(props) {
    super(props);
    const chemicalNames = props.chemicalNames || [];
    this.state = {
      fullChemicalNamesList: chemicalNames,
      chemicalNamesList: this.sliceChemicalNamesList(chemicalNames),
    };

    this.showLessChemicalNames = this.showLessChemicalNames.bind(this);
    this.showMoreChemicalNames = this.showMoreChemicalNames.bind(this);
    this.sliceChemicalNamesList = this.sliceChemicalNamesList.bind(this);
  }

  sliceChemicalNamesList = (chemicalNamesList) => {
    return chemicalNamesList.slice(0, DEFAULT_CHEMICAL_NAMES_COUNT);
  };

  showLessChemicalNames() {
    this.setState((prevState) => ({
      fullChemicalNamesList: prevState.fullChemicalNamesList,
      chemicalNamesList: this.sliceChemicalNamesList(prevState.fullChemicalNamesList),
    }));
  }

  showMoreChemicalNames() {
    return new Promise((resolve) => {
      this.setState((prevState) => ({
        fullChemicalNamesList: prevState.fullChemicalNamesList,
        chemicalNamesList: prevState.fullChemicalNamesList,
      }));
      resolve();
    });
  }

  render() {
    const { chemicalNamesList, fullChemicalNamesList } = this.state;
    const fullChemicalNamesListLength = fullChemicalNamesList.length;

    if (!fullChemicalNamesListLength) {
      return null;
    }
    const chemicalNamesListLength = chemicalNamesList.length;

    return (
      <>
        <tr className="chemical-names-substance-row">
          <th scope="row" rowSpan="2">
            Chemical Names:
          </th>
          <td colSpan={3}>
            {chemicalNamesList.map((name, index) => {
              return (
                <React.Fragment key={name}>
                  <InnerHTML mode="escapeCustom" tag="span" className="dangerously-set-td chemical-names-substance-td" html={name} />
                  {index !== chemicalNamesListLength - 1 && <span className="separator" />}
                </React.Fragment>
              );
            })}
          </td>
        </tr>
        <tr className="chemical-names-substance-row">
          <td className="chemical-names-substance-row__buttonCell" colSpan={3}>
            {fullChemicalNamesListLength > DEFAULT_CHEMICAL_NAMES_COUNT && (
              <div className="els-btn-group-center">
                <ShowMoreComponent
                  labelAll="Show all chemical names"
                  initial={DEFAULT_CHEMICAL_NAMES_COUNT}
                  current={chemicalNamesListLength}
                  total={fullChemicalNamesListLength}
                  container="#rx-substance-identification"
                  moreHandler={this.showMoreChemicalNames}
                  lessHandler={this.showLessChemicalNames}
                />
              </div>
            )}
          </td>
        </tr>
        <tr className="chemical-names-substance-row-outlined" />
      </>
    );
  }
}

SubstanceIdentificationChemicalNamesList.propTypes = {
  chemicalNames: PropTypes.array,
};
